
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';
import { Header } from 'datastake-daf/dist/components';
import AmpTasks from '../../widgets/amp-tasks';
import AmpTimeline from '../../widgets/amp-timeline';
import Style from '../../../../../../Analysis/style';
import AnalysisWidget from '../../../../../../Analysis/widget';
import LayoutStyle from '../../../../../../Analysis/layouts/style';
import Overview from '../../../../../../Analysis/amp-widgets/overview';
import { useEffect, useState } from 'react';
import Loading from '../../../../../../../components/Loading';
import AmpService from '../../../../../../../services/AmpService';

export default function AssessmentAmp() {
  const { t } = useTranslation();
  const [data, setData] = useState({ overview: {} });
  const [loading, setLoading] = useState(true);

  const _fetch = async () => {
    setLoading(true);

    try {
      const { data } = await AmpService.getAmpDashboard()
      setData(data);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    _fetch();
  }, []);

  return (
    <Style>
      {!!loading && <Loading />}

      <Header
        title={t('Dashboard Title')}
        supportText={t("Overview of your organisation's activity and information.")}
        actionButtons={[
          {
            icon: <DownloadOutlined />,
            onClick: () => { },
            disabled: true,
          }
        ]}
      />

      <div className="content">
        <div className="view-content">
          <LayoutStyle>
            <div className='sections-cont w-pt'>
              <section>
                <Overview data={data.overview} />
              </section>

              <section>
                <AnalysisWidget className="with-border-header" title={t('Goals')}>
                  <section>
                    <AmpTimeline data={data.timeline} />
                    <AmpTasks data={data.tasks} />
                  </section>
                </AnalysisWidget>
              </section>
            </div>
          </LayoutStyle>
        </div>
      </div>
    </Style>
  )
}
